import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { SPACING_MAP, SPACING_MAP_INDEX, MEDIA_QUERIES } from '@govuk-react/constants';

var withWhiteSpace = function withWhiteSpace(config) {
  if (config === void 0) {
    config = {};
  }

  return function (Component) {
    var StyledHoc = styled(Component)(function (_ref) {
      var _ref2;

      var _ref$mb = _ref.mb,
          marginBottom = _ref$mb === void 0 ? config.marginBottom : _ref$mb;
      return marginBottom !== undefined ? (_ref2 = {
        marginBottom: marginBottom ? SPACING_MAP[marginBottom].mobile : 0
      }, _ref2[MEDIA_QUERIES.LARGESCREEN] = {
        marginBottom: marginBottom ? SPACING_MAP[marginBottom].tablet : 0
      }, _ref2) : undefined;
    }); // `mb` (Margin Bottom) prop name comes from the naming convention used by https://github.com/jxnblk/grid-styled

    StyledHoc.propTypes = {
      mb: PropTypes.oneOf(SPACING_MAP_INDEX)
    };
    return StyledHoc;
  };
};

export default withWhiteSpace;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/hoc/es/withWhiteSpace/index.js
// module id = 151
// module chunks = 0